import React from "./_snowpack/pkg/react.js";
export const PageNotFoundSection = () => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, "Page Not Found");
};
